const insuranceCollection = require('od-modules/collections/insurance_catalogue.collection').getInstance();
const globalConfig = require('../config/config');
const selectionUtils = require('./selection.utils');

const FLEX_THIRD_PARTY = ['FLEXRB160', 'FLEXRB156', 'FLEXUK164', 'FLEX_AX04', 'UKFLEX_AX11'];
const GUARANTEES_AND_FLEX_THIRD_PARTY = ['CANXSELF', 'FLEXSELF', ...FLEX_THIRD_PARTY];
const SP_ID = 'P';

const getValidator = (binding) => binding.validator || (() => true);

const isValid = (validator, model) => validator(model);

const getMatch = (model) => Odigeo._.find(globalConfig.rules, (binding) => isValid(getValidator(binding), model)) || {};

const getPolicy = ({policy = ''} = {}) => policy;

const getFlexThirdPartyId = () => FLEX_THIRD_PARTY.find((policy) => getPolicy(insuranceCollection.getInsuranceByPolicy(policy)));
const getGuaranteeId = () => GUARANTEES_AND_FLEX_THIRD_PARTY.find((policy) => getPolicy(insuranceCollection.getInsuranceByPolicy(policy)));

module.exports = {

    getPayWithGuaranteeInsuranceId() {
        return getGuaranteeId() || getFlexThirdPartyId();
    },

    getGuaranteeIdBasedOnSessionSelection() {
        return selectionUtils.getGuaranteeIdBasedOnSessionSelection();
    },

    getContinueTracking(model) {
        return getMatch(model).continueTracking;
    },

    calculateTemplate(model) {
        return getMatch(model).template || globalConfig.defaultTemplate;
    },

    mustHideTotalPrice(model) {
        return getMatch(model).hideTotalPrice || false;
    },

    getServicePackId() {
        return SP_ID;
    },
};
